<template>
  <div class="button-widget grid">
    <div class="wrapper">
      <BaseButton
        v-for="button in widget.buttons"
        :key="button.link.label"
        size="l"
        :base-link="button.link"
        :text="button.link.label"
        :color="button.color"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  AlignmentEnum,
  PublicButtonWidget
} from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicButtonWidget>>()

const alignment = computed(() => {
  const alignmentMap: Record<AlignmentEnum, string> = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  }

  return alignmentMap[props.widget.alignment]
})
</script>

<style scoped lang="scss">
.wrapper {
  @include media-column(
    (
      xs: 12
    )
  );
  display: flex;
  flex-wrap: wrap;
  gap: rem(32px);
  align-items: center;
  justify-content: v-bind(alignment);
}
</style>
